import React from 'react';

const CircleLoader = () => (
  <svg
    height="100px"
    preserveAspectRatio="xMidYMid"
    style={{
      background: 'rgb(255, 255, 255)',
      display: 'block',
      margin: 'auto',
      shapeRendering: 'auto',
    }}
    viewBox="0 0 100 100"
    width="150px"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      r="35"
      stroke="#00927c"
      strokeDasharray="164.93361431346415 56.97787143782138"
      strokeWidth="10"
    >
      <animateTransform
        attributeName="transform"
        dur="1s"
        keyTimes="0;1"
        repeatCount="indefinite"
        type="rotate"
        values="0 50 50;360 50 50"
      />
    </circle>
  </svg>
);

export default CircleLoader;
